import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconSort = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M8 18.0859V3.5H6V18.0859L3.70703 15.793L2.29297 17.207L7 21.9141L11.707 17.207L10.293 15.793L8 18.0859Z" }),
            React.createElement("path", { d: "M21.707 7.79297L17 3.08594L12.293 7.79297L13.707 9.20703L16 6.91406V21.5H18V6.91406L20.293 9.20703L21.707 7.79297Z" }))));
};
